export default __webpack_public_path__ + "static/media/yeezy1.78617c32.jpg";